/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_IntroInputs */

const en_welcome_intro = /** @type {(inputs: Welcome_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The RMF server only spins up when a visitor arrives — saves energy when nobody is here. Expect one to two minutes for the first cold start.`)
};

const fr_welcome_intro = /** @type {(inputs: Welcome_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le serveur RMF se réveille uniquement lorsqu'un visiteur arrive, pour ne pas consommer d'énergie inutilement. Comptez environ une à deux minutes au premier démarrage.`)
};

const ms_sg2_welcome_intro = /** @type {(inputs: Welcome_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelayan RMF hanya dihidupkan apabila pelawat tiba — menjimatkan tenaga apabila tiada orang. Jangkakan satu hingga dua minit untuk permulaan kali pertama.`)
};

/**
* | output |
* | --- |
* | "The RMF server only spins up when a visitor arrives — saves energy when nobody is here. Expect one to two minutes for the first cold start." |
*
* @param {Welcome_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_intro = /** @type {((inputs?: Welcome_IntroInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_IntroInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_intro(inputs)
	if (locale === "fr") return fr_welcome_intro(inputs)
	return ms_sg2_welcome_intro(inputs)
});